import { gql } from '../../../../__generated__/gql';

export const USER_CORE_FRAGMENT = gql(/* GraphQL */ `
  fragment UserCore on User {
    id
    username
    firstName
    lastName
    createdAt
    updatedAt
    role
    flag
    state
    profileTheme
    themeColors
    customThemeId
    customTheme {
      id
      name
      colors
      updatedAt
    }
    isPremium
    premiumTier
    signUpStep
    substackStatus
    location
    instagram
    twitter
    website
    links
    bio
    isShadowBanned
    siteUrl
    isOnline
    avatarPhotoSrc
    relationshipStatus
    interestedIn
    avatarPhotoFile {
      ...PerfImageFromFile
    }
    profilePhotoSrc
    profilePhotoFile {
      ...PerfImageFromFile
    }
  }
`);
